import DateTimePicker from "react-datetime-picker"

type CustomDateTimePickerProps = Parameters<typeof DateTimePicker>[0]

const CustomDateTimePicker = (props: CustomDateTimePickerProps) => {

    const defaultProps: CustomDateTimePickerProps = {
        disableClock: true,
        ...props
    }

    return (
        <DateTimePicker {...defaultProps} />
    )
}

export default CustomDateTimePicker;